import { BetBuilderMarket, BetBuilderStatType, MarketType } from '@/interface/enum';

interface BetBuilderMarketMapping {
    fullTime: MarketType;
    firstHalf: MarketType;
}

const BetBuilderMarketTypeToMarketTypeMapping: Partial<Record<BetBuilderMarket, BetBuilderMarketMapping>> = {
    [BetBuilderMarket.Set1x2]: {
        fullTime: MarketType._1X2,
        firstHalf: MarketType.FH_1X2,
    },
    [BetBuilderMarket.SetDoubleChance]: {
        fullTime: MarketType.DoubleChance,
        firstHalf: MarketType.DoubleChance,
    },
    [BetBuilderMarket.SetTotalGoalsOverUnder]: {
        fullTime: MarketType.OverUnder,
        firstHalf: MarketType.FH_OverUnder,
    },
    [BetBuilderMarket.SetTotalGoalsOddEven]: {
        fullTime: MarketType.OddEven,
        firstHalf: MarketType.FH_OddEven,
    },
    [BetBuilderMarket.SetCorrectScore]: {
        fullTime: MarketType.CorrectScore,
        firstHalf: MarketType.FH_CorrectScore,
    },
    [BetBuilderMarket.SetHandicap]: {
        fullTime: MarketType.Handicap,
        firstHalf: MarketType.FH_Handicap,
    },
    [BetBuilderMarket.SetExactNumberGoals]: {
        fullTime: MarketType.TotalGoal,
        firstHalf: MarketType.TotalGoal,
    },
    [BetBuilderMarket.SetTotalCornersHandicap]: {
        fullTime: MarketType.Handicap,
        firstHalf: MarketType.FH_Handicap,
    },
    [BetBuilderMarket.SetTotalCornersOverUnder]: {
        fullTime: MarketType.OverUnder,
        firstHalf: MarketType.FH_OverUnder,
    },
    [BetBuilderMarket.SetTotalCornersOddEven]: {
        fullTime: MarketType.OddEven,
        firstHalf: MarketType.FH_OddEven,
    },
    [BetBuilderMarket.SetTotalCorners1x2]: {
        fullTime: MarketType._1X2,
        firstHalf: MarketType.FH_1X2,
    },
};

const firstHalfStatTypes = new Set<BetBuilderStatType>([
    BetBuilderStatType.FirstHalf,
    BetBuilderStatType.FirstHalfCorners,
]);

export function betBuilderToMarketType(
    betBuilderMarketType: BetBuilderMarket,
    statType: BetBuilderStatType,
): MarketType | undefined {
    const mapping = BetBuilderMarketTypeToMarketTypeMapping[betBuilderMarketType];
    if (!mapping) {
        return undefined;
    }

    return firstHalfStatTypes.has(statType)
        ? mapping.firstHalf
        : mapping.fullTime;
}
